import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ThankYou() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [navigate]);

  const scrollToForm = () => {
    navigate('/');
    setTimeout(() => {
      const formSection = document.getElementById('seller-form');
      if (formSection) formSection.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Nav */}
      <nav className="w-full px-4 md:px-8 py-2 md:py-3 flex items-center justify-between border-b border-gray-100">
        <a href="/" className="cursor-pointer">
          <img
            src="https://static.readdy.ai/image/a48e56127586ecde9cf388aadcd5ef1b/19c26b1626dd19f7cd936f84555985c9.jpeg"
            alt="GreenState Investments"
            className="h-14 md:h-20 w-auto"
          />
        </a>
        <a
          href="tel:202-600-9590"
          className="flex items-center gap-2 text-emerald-700 font-semibold text-sm hover:text-emerald-500 transition-colors cursor-pointer"
        >
          <i className="ri-phone-line"></i>
          <span className="hidden sm:inline">202-600-9590</span>
        </a>
      </nav>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-2xl w-full text-center">
          {/* Success Icon */}
          <div className="w-24 h-24 flex items-center justify-center bg-emerald-100 rounded-full mx-auto mb-8">
            <i className="ri-checkbox-circle-fill text-5xl text-emerald-600"></i>
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            You're All Set!
          </h1>
          <p className="text-xl text-emerald-600 font-semibold mb-6">
            We've received your information.
          </p>
          <p className="text-lg text-gray-600 mb-10 max-w-xl mx-auto leading-relaxed">
            A member of our team will review your property details and reach out to you within <strong>24 hours</strong> with a fair, no-obligation cash offer.
          </p>

          {/* What Happens Next */}
          <div className="bg-gray-50 rounded-lg p-8 mb-10 text-left">
            <h2 className="text-xl font-bold text-gray-900 mb-6 text-center">What Happens Next</h2>
            <div className="space-y-5">
              <div className="flex items-start gap-4">
                <div className="w-9 h-9 flex items-center justify-center bg-emerald-600 text-white rounded-full font-bold text-sm shrink-0">1</div>
                <div>
                  <p className="font-semibold text-gray-900">We review your property</p>
                  <p className="text-gray-500 text-sm mt-0.5">Our team analyzes your submission and researches your property details.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-9 h-9 flex items-center justify-center bg-emerald-600 text-white rounded-full font-bold text-sm shrink-0">2</div>
                <div>
                  <p className="font-semibold text-gray-900">You receive a cash offer within 24 hours</p>
                  <p className="text-gray-500 text-sm mt-0.5">We'll call or email you with a fair, no-obligation offer — no pressure.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-9 h-9 flex items-center justify-center bg-emerald-600 text-white rounded-full font-bold text-sm shrink-0">3</div>
                <div>
                  <p className="font-semibold text-gray-900">You choose your closing date</p>
                  <p className="text-gray-500 text-sm mt-0.5">Accept the offer and pick a date that works for you — we can close in as little as 7 days.</p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
            <a
              href="tel:202-600-9590"
              className="flex items-center justify-center gap-2 bg-emerald-600 text-white px-8 py-3.5 rounded-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              Call Us: 202-600-9590
            </a>
            <button
              onClick={scrollToForm}
              className="flex items-center justify-center gap-2 border-2 border-emerald-600 text-emerald-600 px-8 py-3.5 rounded-lg font-semibold hover:bg-emerald-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-4-line"></i>
              Submit Another Property
            </button>
          </div>

          {/* Auto redirect notice */}
          <p className="text-sm text-gray-400">
            Redirecting you to the homepage in <span className="font-semibold text-gray-500">{countdown}</span> seconds...
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-emerald-700 text-white py-5 px-6 text-center">
        <p className="text-emerald-100 text-sm">
          © 1998 – {new Date().getFullYear()} GreenState Investments. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
